import { createSelector } from '@reduxjs/toolkit';
import { selectSearchMetaData } from './selectSearchMetaData';
import { numberToPrettyString, plural } from '@cian/utils';

export const selectSearchResultsText = createSelector(selectSearchMetaData, searchMeta => {
  const offersCount = searchMeta?.count;

  if (typeof offersCount === 'undefined') {
    return 'Показать объекты';
  }

  return `Показать ${numberToPrettyString(offersCount)} ${plural(offersCount, ['объект', 'объекта', 'объектов'])}`;
});
